<template>
  <div
    :id="`editorForm${ parent }`"
    class="c-editor c-form c-form--black"
    :class="{ active : textarea.active}">
    <div class="d-flex">
      <Avatar
        :role="userRole"
        :photo="user.photo"
        :name="user.name"
        class="d-none d-md-block me-3"
        :class="(category == 'comment') ? 'c-avatar--regular' : 'c-avatar--tiny'"
      >
      </Avatar>
      <div class="c-editor__textarea flex-grow-1">
        <div class="c-atachments d-flex flex-wrap">
          <div
            v-for="(attachment, aindex) of attachments.data"
            :key="attachment.id"
            >
            <div
              v-if="attachment.status != -2"
              class="c-atachment"
              :class="[{'c-atachment--error' : attachment.status == 0},
                {'loaded' : attachment.status == 2}]"
            >
              <figure class="c-atachment__photo position-relative">
                <button
                  v-if="attachment.status == -1"
                  @click="cancelUploadFile(attachment.id, aindex)"
                  class="c-atachment__cancel position-absolute">
                  <i class="iconf-cancel d-flex align-items-center"></i>
                </button>
                <div
                  class="c-atachment__overlay position-absolute d-flex
                    justify-content-center align-items-center"
                >
                  <span v-if="attachment.status == 0" class="white fs-14 w-sbold">😢 Error</span>
                  <button
                    @click="handleDeleteFile(attachment.idRemote, aindex)"
                    v-if="attachment.status == 2"
                    class="c-atachment__trash d-flex justify-content-center align-items-center"
                    :disabled="attachment.isDeleting">
                    <i class="iconf-trash d-flex align-items-center"></i>
                  </button>
                </div>
                <img class="of--cover w-100 h-100" :src="attachment.src" alt="">
              </figure>
              <div v-if="attachment.status != 2" class="c-atachment__walk position-relative">
                <div
                  class="c-atachment__progress position-absolute"
                  :style="`width: ${attachment.progress}%`"
                >
                </div>
              </div>
            </div>
          </div>
        </div>
        <textarea
          class="c-form__textarea w-100"
          :class="{'error' : isWrongField(textarea.content)}"
          :placeholder="(category == 'comment')
            ? 'Comparte tus ideas, dudas, etc.'
            : 'Responde y unete a esta discusión'"
          @focus="textarea.active = true"
          v-model="textarea.content.value"
          :style="{'height': autoHeight}"
          @input="autoRezise">
        </textarea>
        <p v-if="isWrongField(textarea.content)" class="c-form__error">Contenido vacio</p>
        <div
          :id="`drop-comment-area-${parent}`"
          v-if="category == 'comment'"
          class="c-editor__selectors d-flex align-items-center"
        >
          <div v-if="mode === 'post'" class="c-checkboxes d-flex">
            <div class="c-checkbox me-2">
              <input
                id="cb-comment"
                type="radio"
                class="d-none"
                value="comment"
                v-model="type.value"
              >
              <label
                for="cb-comment"
                class="c-checkbox__label d-flex justify-content-center align-items-center"
              >
                <span class="c-checkbox__buble me-2"></span>
                <p class="c-checkbox__name mb-0">Comentario</p>
              </label>
            </div>
            <div class="c-checkbox">
              <input
                id="cb-question"
                type="radio"
                class="d-none"
                value="question"
                v-model="type.value"
              >
              <label
                for="cb-question"
                class="c-checkbox__label d-flex justify-content-center align-items-center"
              >
                <span class="c-checkbox__buble me-2"></span>
                <p class="c-checkbox__name mb-0">Pregunta</p>
              </label>
            </div>
          </div>
          <label class="c-editor__atachment c-link c-link--white d-flex align-items-center">
            <i class="iconf-add-image d-flex align-items-center"></i>
            <span class="ms-2">Añadir imágenes</span>
            <input type="file" class="d-none" accept=".jpg, .png, .jpeg, .PNG">
          </label>
        </div>
        <div
          :id="`drop-comment-area-${parent}`"
          v-else
          class="c-editor__selectors d-flex align-items-center"
        >
          <label class="c-editor__atachment c-link c-link--white d-flex align-items-center">
            <i class="iconf-add-image d-flex align-items-center"></i>
            <span class="ms-2">Añadir imágenes</span>
            <input type="file" class="d-none" accept=".jpg, .png, .jpeg, .PNG">
          </label>
        </div>
      </div>
    </div>
    <div
      v-if="textarea.active"
      class="c-editor__actions d-flex mt-4"
      :class="{extended : isFreeCourse}"
    >
      <p v-if="isFreeCourse" class="medium-gray d-block mb-4 mb-md-0">
        Deja tus comentarios o preguntas y recibirás respuestas de tus compañeros.
        Recuerda que este es un curso gratuito y no podemos exigir respuestas al docente.
      </p>
      <div class="text-right d-flex flex-column align-items-end">
        <div class="d-flex">
          <button @click="closeEditor" class="c-link c-link--white me-3">Cancelar</button>
          <button
            class="c-button c-button--primary"
            :disabled="!isReadyComment || isLoading"
            :class="{ loading : isLoading }"
            @click="sendComment">
            {{sendButton}}
            <img
              class="c-button__spinner"
              src="../../../assets/images/animations/spinner-white.png" alt="loading"
            />
          </button>
        </div>
        <p
          v-if="isWrongField(type) && category == 'comment' && mode === 'post'"
          class="c-form__error mt-3 mb-0 w-100">
          Clasifica tu aporte como “comentario” o “pregunta”
        </p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import 'dm-file-uploader';

import { mapState } from 'vuex';

import Avatar from '../../Avatar.vue';

export default {
  data(){
    return {
      arcux: window.arcux,
      user: {},
      type: {
        value: '',
        isValid: false,
      },
      attachments: {
        isReady: true,
        isChanged: false,
        ids: {},
        data: [],
      },
      textarea: {
        content: {
          value: '',
          isValid: false,
        },
        height: 54,
        active: false,
      },

      trySend: false,
      isLoading: false,
    }
  },
  components: {
    Avatar,
  },
  props: {
    switcher: Boolean,
    parent: [String, Number],
    mode: String,
    category: String,
    recents: Array,
    thread: Array,
    comment: Object,
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
      courseData: (state) => state.course.data,
    }),

    sendButton: function() {
      if (this.isLoading) {
        return (this.mode === 'post') ? 'Publicando...' : 'Actualizando...';
      } else {
        if (this.mode === 'post') {
          if (this.category == 'comment') {
            return (this.type.value == 'comment') ? 'Comentar' : 'Preguntar';
          } else {
            return 'Responder';
          }
        } else {
          return 'Actualizar';
        }
      }
    },
    autoHeight: function() {
      return this.textarea.height + 'px';
    },
    isReadyComment: function() {
      const isReadyTextarea = (this.mode === 'update')
        ? (this.textarea.content.value !== this.comment.text || this.attachments.isChanged)
        : true;

      return this.attachments.isReady && isReadyTextarea ? true : false;
    },
    isFreeCourse: function() {
      return (this.courseData.is_free) ? true : false;
    },

    userRole() {
      return (this.user && this.user.id)
        ? (this.user.membership) ? 'subscriber' : this.user.roles[0]
        : '';
    },
  },
  watch: {
    'textarea.content.value': function() {
      this.textarea.content.isValid = (this.textarea.content.value.length >= 1) ? true : false;
    },
    'type.value': function() {
      this.type.isValid = (this.type.value.length) ? true : false;
    },

    userData(data) {
      this.user = data;

      this.init();
    },
  },
  mounted() {
    this.user = this.userData;

    if (this.user) this.init();
    if (this.comment) {
      this.textarea.content.value = this.comment.text;
      this.textarea.content.isValid = true;

      if (this.comment.attachments) {
        this.attachments.data = this.comment.attachments;
      }
    }
  },
  methods: {
    isWrongField: function(field) {
      return this.trySend && !field.isValid;
    },
    init: function() {
      $(`#drop-comment-area-${this.parent}`).dmUploader({
        auto: true,
        queue: true,
        url: `${this.arcux.site}/api/v1/courses/${this.$route.params.course_id}/annotations/attachments`,
        method: 'POST',
        maxFileSize: 300000000,
        fieldName: 'image',
        dataType: 'json',
        extraData: () => {
          return {
            'user': this.user.id,
          }
        },
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
        extFilter: ['png', 'jpg', 'jpeg'],
        onNewFile: this.addNewFile,
        onUploadProgress: this.updateProgressFile,
        onUploadCanceled: this.handleCancel,
        onBeforeUpload: this.handleBeforeUpload,
        onUploadError: this.handleError,
        onUploadSuccess: this.handleUploadSuccess,
        onUploadComplete: this.handleUploadComplete,
        onFileSizeError: this.handleFileSizeError,
        onFileExtError: this.handleFileExtError,
        onComplete: this.handleAllFilesCompleted,
      });
    },

    closeEditor: function() {
      this.textarea.active = false;

      if(this.category == 'answer' || this.mode === 'update')
        this.$emit('update:switcher', false);
    },
    sendComment: function() {
      this.trySend = true;

      const isEditorValid = this.textarea.content.isValid && ( (this.category == 'comment' && this.mode === 'post') ? this.type.isValid : true );

      if (isEditorValid) {
        if (this.mode === 'post') this.postComment();
        else this.updateComment();
      }
    },
    postComment() {
        let formData = new FormData()

        this.attachments.data = this.attachments.data.filter(atch => atch.status != -2);
        this.isLoading        = true;

        formData.append('user', this.user.id);
        formData.append('course', this.$route.params.course_id);
        formData.append('module', this.$route.params.module);
        formData.append('lesson', this.$route.params.lection_slug);
        formData.append('type', this.type.value);
        formData.append('parent', this.parent ? this.parent : 0);
        formData.append('level', this.parent ? this.parent : 1);
        formData.append('text', this.textarea.content.value);
        formData.append('attachment', this.attachments.data.map(atch => atch.idRemote).join());

        fetch(`${window.arcux.site}/api/v1/courses/${this.$route.params.course_id}/${this.$route.params.module}/${this.$route.params.lection_slug}/annotations`,{
            method: 'POST',
            body: formData,
            headers: {
              Authorization: `Bearer ${window.arcux.token}`,
            },
        })
          .then(res => {
            if (res.status == 201 || res.status < 300) {
              return res.json();
            } else {
              throw res;
            }
          })
          .then(comment => {
            this.updateThread(comment);

            this.$emit('update:recents', [
              ...this.recents,
              comment.id,
            ])
            this.$emit('update:switcher', false);

            this.attachments.data       = [];
            this.attachments.ids        = {};
            this.type.value             = '';
            this.textarea.content.value = '';
            this.textarea.active        = false;
            this.trySend                = false;

            window.setTimeout(() => {
              this.isLoading = false;
            }, 1000)
          })
          .catch(err => {
            throw err;
          })
    },
    updateComment() {
      this.attachments.data = this.attachments.data.filter(atch => atch.status != -2);
      this.isLoading = true;

      fetch(`${window.arcux.site}/api/v1/courses/${this.$route.params.course_id}/annotations/${this.comment.id}`,{
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${window.arcux.token}`,
        },
        body: JSON.stringify({
          text: this.textarea.content.value,
          ...(this.attachments.isChanged && {attachment: this.attachments.data.map(atch => atch.idRemote).join()}),
        }),
      })
        .then(res => {
          if (res.status == 201 || res.status < 300) {
            return res.json();
          } else {
            throw res;
          }
        })
        .then(response => {
          if (response.status) {
            const newThread = this.thread.map((com) => {
              return {
                ...com,
                text: this.textarea.content.value,
                attachments: (com.id == this.comment.id)
                  ? this.attachments.data
                  : com.attachments
              };
            })

            this.$emit('update:thread', newThread);

            this.closeEditor();
          }
        })
        .catch(err => {
          throw err;
        })
        .finally(() => {
          this.isLoading = false;
        })
    },

    updateThread: function(comment) {
      let date = '';

      if (comment.date.includes('-')) {
        date = (new Date(comment.date)).toLocaleDateString('es', { weekday: 'long', month: 'long', day: 'numeric' });
      } else {
        date = comment.date;
      }

      const element = {
          id: comment.id,
          user: {
            id: Number(this.user.id),
            photo: this.user.photo,
            name: this.user.name,
            role: this.userRole,
          },
          date: date,
          type: this.type.value,
          text: this.textarea.content.value,
          attachments: this.attachments.data,
          answers: {
            total: 0,
            data: [],
          },
        };

      console.log(element);

      const thread = this.category !== 'comment'
        ? [...this.thread, element]
        : [element, ...this.thread];

      this.$emit('update:thread', thread);
    },
    autoRezise: function(event) {
      let lines,
          element    = event.target,
          lineHeight = parseInt(getComputedStyle(element).lineHeight);

      lines = parseInt(element.scrollHeight/lineHeight)

      this.textarea.height   = lineHeight * lines;
      element.style.overflow = 'hidden';

      if (this.textarea.height > 250) {
        element.style.overflow = 'auto';
      }
    },
    cancelUploadFile: function(id, index) {
      $(`#drop-comment-area-${this.parent}`).dmUploader('cancel', id);
    },
    addNewFile: function(id, file) {
      this.attachments.isReady = false;

      const reader = new FileReader();

      reader.onload = (e) => {
        this.attachments.data.push({
          id: id,
          idRemote: -1,
          src: e.target.result,
          url: '',
          status: -1,
          progress: 0,
          isDeleting: false,
        })

        this.attachments.ids[id] = {
          id: id,
          index: this.attachments.data.length - 1,
        }
      }

      reader.readAsDataURL(file);
    },
    getFileIndex: function(id) {
      return this.attachments.ids[id].index;
    },
    updateProgressFile: function(id, percent) {
      this.attachments.data[this.getFileIndex(id)].progress = percent;
    },
    handleError: function(id) {
      this.attachments.data[this.getFileIndex(id)].status = 0;
    },
    handleCancel: function(id) {
      this.attachments.data[this.getFileIndex(id)].progress = 0;
      this.attachments.data[this.getFileIndex(id)].status   = -2;
    },
    handleDeleteFile: function(idRemote, index) {
      this.attachments.isReady = false;
      this.attachments.data[index].isDeleting = true;

      fetch(`${this.arcux.site}/api/v1/courses/${this.$route.params.course_id}/annotations/attachments/${idRemote}`,{
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
      .then(res => {
        if (res.status == 201 || res.status < 300) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then(response => {
        this.attachments.isReady = true;

        window.setTimeout(() => {
          this.attachments.data[index].progress   = 0;
          this.attachments.data[index].status     = -2;
          this.attachments.data[index].isDeleting = false;

          if (this.mode === 'update') {
            const newThread = this.thread.map((com) => {
              return {
                ...com,
                attachments: (com.id == this.comment.id)
                  ? this.attachments.data.filter((img) => img.status !== -2)
                  : com.attachments
              };
            })

            this.$emit('update:thread', newThread);

            this.closeEditor();
          }
        }, 200)
      })
      .catch(err => {
        throw err;
      })
    },
    handleUploadSuccess: function(id, response) {
      this.attachments.data[this.getFileIndex(id)].status   = 1;
      this.attachments.data[this.getFileIndex(id)].url      = response.data.path;
      this.attachments.data[this.getFileIndex(id)].idRemote = response.data.id;
    },
    handleUploadComplete: function(id) {
      this.attachments.data[this.getFileIndex(id)].status = 2;
    },
    handleAllFilesCompleted: function() {
      this.attachments.isReady = true;
      this.attachments.isChanged = true;
    },
    handleFileSizeError: function(file) {
      alert('Archivo muy pesado')
    },
    handleFileExtError: function(file) {
      alert('Archivo muy no permitido')
    },
  },
}
</script>
